import React from 'react';
import { AnalysisEntitlement } from '../../../services/subscriptionService';
import './SubscriptionBanner.css';

/**
 * Persistent banner for trial and grace-period states; renders nothing for
 * active/locked states (locked states are handled by SubscriptionGate).
 */
const SubscriptionBanner: React.FC<{ entitlement: AnalysisEntitlement }> = ({ entitlement }) => {
  if (entitlement.status === 'trial') {
    const days = entitlement.trial_days_remaining;
    return (
      <div className="subscription-banner subscription-banner--trial">
        ⏳ Trial{days !== undefined ? `: ${days} day${days === 1 ? '' : 's'} remaining` : ''} — contact
        your HCP representative to subscribe.
      </div>
    );
  }
  if (entitlement.status === 'expired_grace') {
    const days = entitlement.grace_days_remaining;
    return (
      <div className="subscription-banner subscription-banner--grace">
        ⚠️ Subscription expired — grace period{days !== undefined ? `: ${days} day${days === 1 ? '' : 's'} remaining` : ''}.
        Renew to keep access to Analysis.
      </div>
    );
  }
  return null;
};

export default SubscriptionBanner;
